import React from "react";
import ReactDOM from "react-dom/client";
import Cookies from "js-cookie";
import { configureApiClient } from "@shared/api/client";
import "@/index.css";
import App from "@/App";

// PR 11 ST 2 — CRA bootstrap. Vite shells call configureApiClient()
// from their own main.tsx with `import.meta.env`. See
// memory/project_pr10_api_client_deferred_factory.md.
configureApiClient({
  baseURL: process.env.REACT_APP_BACKEND_URL ?? "",
  getToken: () => Cookies.get("staff_token") ?? null,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
